import api from "../api";

class ReportsService {

	//setups/sales report data
	// calls proc spGetSalesReport
	async getSalesReport(filters) {
		return new Promise((res, reject) => {
			let params = {
				page: 0,
				pageSize: 10000,
				pointsOnlyProducts: filters.pointsOnlyProducts,
				startDate: filters.startDate,
				endDate: filters.endDate,
				users: filters.users || [],
			};
			api
				.get("/reports/salesNative", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//activity report data
	// calls proc spGetActivityReport
	async getActivityReport(filters) {
		return new Promise((res, reject) => {
			let params = {
				page: 0,
				pageSize: 10000,
				startDate: filters.startDate,
				endDate: filters.endDate,
				users: filters.users || [],
				location: filters.location || [],
			};
			api
				.get("/reports/activity", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//approvals report data
	async getApprovalsReport(filters) {
		return new Promise((res, reject) => {
			let params = {
				page: 0,
				pageSize: 10000,
				pointsOnlyProducts: filters.pointsOnlyProducts,
				startDate: filters.startDate,
				endDate: filters.endDate,
				users: filters.users || [],
			};
			api
				.get("/reports/approvals", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//approvals report data
	// calls proc spApprovalReport
	async getApprovalsReportNative(filters) {
		return new Promise((res, reject) => {
			api
				.get("/reports/approvalsNative", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//service report data
	// calls proc spGetServiceReport
	async getServiceReport(filters) {
		return new Promise((res, reject) => {
			api
				.get("/reports/servicesNative", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//delivery report data
	// calls proc spGetDeliveryReport
	async getDeliveryReport(filters) {
		return new Promise((res, reject) => {
			let params = {
				startDate: filters.startDate,
				endDate: filters.endDate,
				users: filters.users,
			};
			api
				.get("/reports/deliveryNative", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//expense report data
	// calls proc spGetExpensesReport
	async getExpensesReport(filters) {
		return new Promise((res, reject) => {
			let params = {
				startDate: filters.startDate,
				endDate: filters.endDate,
				users: filters.users,
			};
			//exec spGetExpensesReport :ids, :from, :until
			api
				.get("/reports/expensesNative", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//accounts report data
	// calls proc spGetAccountReport
	async getAccountsReport(filters) {
		return new Promise((res, reject) => {
			let params = {
				startDate: filters.startDate,
				endDate: filters.endDate,
				users: filters.users,
			};
			api
				.get("/reports/accountsNative", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	// calls proc spCalcRepBonus
	async getBonusReport(filters) {
		return new Promise((res, reject) => {
			api
				.get("/bonusNative", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	// calls TWO procs
	// calls proc spProductionMonthly
	// calls proc spProductionMonthlyNotatedOrders
	async getProductionReport(filters) {
		return new Promise((res, rej) => {
			api
				.get("/reports/productionReport", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					rej();
				});
		});
	}

	// calls proc spGetOrderCountsByDay
	async getDailyOrderCounts(filters) {
		return new Promise((res, rej) => {
			api
				.get("/orderCountsByDayNative", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					rej(err);
				});
		});
	}

	// calls proc spOrderCountsByDayByLocation
	async getDailyOrderCountsLocation(filters) {
		return new Promise((res, rej) => {
			api
				.get("/orderCountsByDayLocationNative", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					rej(err);
				});
		});
	}
}

const reportsService = new ReportsService();
export default reportsService;
